/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import * as _ from 'lodash'
import {
  formatNumber,
  formatNumberTicketCount,
  getGiftTypeName,
  getTicketCountFromTicket,
  getTicketFromTicketCount,
  showToast,
  TOAST_TYPE,
} from '@utils/utils'
// icon
import { HeartIco } from '@shared/Icon/MoneyIcon'
// css
import { Point } from '@styles/base.style'
import { Button, FooterBtnStyle } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { MESSAGE_TYPE, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import { BET_TICKET_TYPE, GIFT_BTN_TYPE } from '@constants/index'
import { MessageWrap, Num, PointStyle } from './index.style'
import AdvImg from '@components/AdvImg'

const Heart = (
  <HeartIco/>
)

interface MessageContentProps {
  nick: string
  isCustomProfile: boolean
  profile: string
  visible: boolean
  setVisible: (arg: boolean) => void
}

const BettorGiftContent: React.FC<MessageContentProps> = (props: MessageContentProps) => {
  const { authStore, messageStore, bettorStore } = useRootStore()
  const { signedin, userInfo } = authStore
  const { nick, isCustomProfile, profile, setVisible } = props
  const { giftBtnType } = bettorStore

  const [giftCount, setGiftCount] = useState(0)
  const [updater, setUpdater] = useState(0)
  const [loading, setLoading] = useState(false)
  const giftName = getGiftTypeName(giftBtnType)

  const onShowChildPopup = async (inputNick, inputProfile, inputHeart) => {
    try {
      if (loading) {
        return
      }

      const formData = new FormData()
      formData.append('receiverNick', inputNick)
      formData.append('receiverProfile', inputProfile)
      formData.append('messageType', _.toString(MESSAGE_TYPE.GIFT))
      formData.append('itemCount', _.toString(giftBtnType === GIFT_BTN_TYPE.HEART ? inputHeart : getTicketFromTicketCount(BET_TICKET_TYPE.BET_TICKET1, inputHeart)))
      formData.append('itemCode', _.toString(giftBtnType === GIFT_BTN_TYPE.HEART ? PROPERTY_ID.HEART : PROPERTY_ID.NEW_BET_TICKET_G))
      setLoading(true)
      const errMsg = await messageStore.sendMessage(formData)
      setLoading(false)
      if (errMsg.length === 0) {
        showToast(TOAST_TYPE.INFO, `${giftName} 보내기를 완료했습니다`)
      } else {
        showToast(TOAST_TYPE.INFO, `${errMsg}`)
      }
    } catch (e) {
      setLoading(false)
      showToast(TOAST_TYPE.INFO, `${giftName} 보내기 실패!  잠시후 다시 시도해주세요.`)
    }
  }

  const doChangeSendHeart = sendHeart => {
    if (sendHeart > userInfo.heart) {
      showToast(TOAST_TYPE.INFO, '하트가 부족합니다.')
      setGiftCount(userInfo.heart)
      setUpdater(updater + 1)
    } else {
      setGiftCount(sendHeart)
    }
  }

  const doChangeSendTicket = sendTicket => {
    if (sendTicket > getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket)) {
      showToast(TOAST_TYPE.INFO, '베팅권이 부족합니다.')
      setGiftCount(getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket))
      setUpdater(updater + 1)
    } else {
      setGiftCount(sendTicket)
    }
  }

  let giftMoneyInfo = null
  if (giftBtnType === GIFT_BTN_TYPE.HEART) {
    if (signedin) {
      giftMoneyInfo = (
        <Fragment>
          <Num>{formatNumber(userInfo.heart)}</Num>
          <span className="list-item-type">
          {Heart}
      </span>
        </Fragment>
      )
    }
  } else if (giftBtnType === GIFT_BTN_TYPE.TICKET) {
    if (signedin) {
      giftMoneyInfo = (
        <Fragment>
          <Num>{formatNumberTicketCount(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket)}</Num>
          <span className="list-item-type">
          개
        </span>
        </Fragment>
      )
    }
  }

  const onChangeCount = async (values: NumberFormatValues) => {
    if (giftBtnType === GIFT_BTN_TYPE.HEART) {
      doChangeSendHeart(values.floatValue)
    } else {
      doChangeSendTicket(values.floatValue)
    }
  }

  const onClickGiftSendButton = async () => {
    if (giftCount > 0) {
      setVisible(false)
      await onShowChildPopup(nick, profile, giftCount)
    } else {
      showToast(TOAST_TYPE.INFO, `선물할 ${giftName}를 입력해 주세요.`)
    }
  }

  return (
    <Fragment>
      <MessageWrap className="bettor-heart message-wrap">
        <div className="bettor-profile-img-wrap lhn28">
          {isCustomProfile ?
            (<AdvImg src={profile} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img"/>)
            :
            (<AdvImg src={profile} srcMode={'small'} alt="스킨 프로필" className="profile-img"/>)
          }
        </div>
        <h3 className="tit">
          <Point css={PointStyle}>{nick}</Point> 님께
          <br/>
          {`${giftName}`}를 선물하시겠습니까?
        </h3>
        <div className="heart-wrap">
          <ul className="heart-wrap--list">
            <li className="heart-wrap--list--item">
              <span className="list-item-txt">선물할 {`${giftName}`}</span>
              <span className="list-item-quantity">
                <NumberFormat
                  pattern="\d*"
                  maxLength={20}
                  decimalScale={0}
                  allowNegative={false}
                  value={giftCount}
                  thousandSeparator
                  onValueChange={onChangeCount}
                />
                <span className="list-item-type">
                  {giftBtnType === GIFT_BTN_TYPE.HEART ? Heart : '개'}
                </span>
              </span>
            </li>

            <li className="heart-wrap--list--item sub">
              <span className="list-item-txt">보유{`${giftName}`}</span>
              <span className="list-item-quantity">
                {giftMoneyInfo}
              </span>
            </li>
          </ul>
        </div>

        <Button secondary css={FooterBtnStyle} onClick={onClickGiftSendButton} className="one-btn dark">
          보내기
        </Button>

      </MessageWrap>
    </Fragment>
  )
}

export default observer(BettorGiftContent)
